import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=37034e0d&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37034e0d')) {
      api.createRecord('37034e0d', component.options)
    } else {
      api.reload('37034e0d', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=37034e0d&", function () {
      api.rerender('37034e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Layout/Breadcrumbs.vue"
export default component.exports